import TransparentAccordion from '~/components/accordion/sd/TransparentAccordion'
import { RestaurantAccesses } from '~/lib/accesses/RestaurantAccesses.frag'
import type { FragmentType } from '~/lib/graphql'
import { getFragmentData } from '~/lib/graphql'
import { RestaurantFaqFragment } from '../shared/RestaurantFaq.frag'

type Props = {
  restaurant: FragmentType<typeof RestaurantFaqFragment> & FragmentType<typeof RestaurantAccesses>
}

export function RestaurantFaq({ restaurant }: Props) {
  const faq = getFragmentData(RestaurantFaqFragment, restaurant)
  const access = getFragmentData(RestaurantAccesses, restaurant).accesses.find(
    (access) => access.__typename === 'RestaurantAccessTrain'
  )

  return (
    <section className="p-3">
      <h3 className="text-lg font-bold">よくあるご質問</h3>
      <TransparentAccordion>
        <ul itemScope itemType="https://schema.org/FAQPage" className="mt-3 space-y-3">
          {access && (
            <FaqItem question="この店舗の最寄りの駅からの行き方は？">
              {access.line}線　{access.station}駅　{access.note}
            </FaqItem>
          )}
          <FaqItem question="この店舗の営業時間は？">
            {faq.openingHoursText}
            <br />
            ※（）内の時間はラストオーダーの時間です。
          </FaqItem>
        </ul>
      </TransparentAccordion>
    </section>
  )
}

function FaqItem({ question, children }: React.PropsWithChildren<{ question: string }>) {
  return (
    <li
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/Question"
      className="flex flex-col gap-y-2 border border-neutral-300 p-2"
    >
      <h4 className="flex gap-x-1 font-bold">
        <span className="text-base font-bold">Q.</span>
        <span itemProp="name">{question}</span>
      </h4>
      <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
        <p className="flex gap-x-1 whitespace-pre-wrap border-t border-dashed border-neutral-300 pt-2 text-sm leading-relaxed">
          <span className="text-base font-bold text-accent-brown">A.</span>
          <span itemProp="text">{children}</span>
        </p>
      </div>
    </li>
  )
}
